export const base = '/customer/:id/:subTab?';